// extracted by mini-css-extract-plugin
export default {"Modal":"Register_Modal__Q9Fii","Form":"Register_Form__n1Atx"};